export const SOCKET_ONOPEN = 'SOCKET_ONOPEN'
export const SOCKET_ONCLOSE = 'SOCKET_ONCLOSE'
export const SOCKET_ONERROR = 'SOCKET_ONERROR'
export const SOCKET_ONMESSAGE = 'SOCKET_ONMESSAGE'
export const SOCKET_RECONNECT = 'SOCKET_RECONNECT'
export const SOCKET_RECONNECT_ERROR = 'SOCKET_RECONNECT_ERROR'
